import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import loginApi from "../services/loginApi";
import { LOGOUT_RESPONSE, LOGOUT_FAILED } from '../redux/types/init';

let api = new loginApi();

export function* logout() {
    try {
        let { data } = yield api.logout();
        let getItem = localStorage.getItem('pageUrl');
        if (getItem == "quickbuy") {
            localStorage.removeItem('pageUrl')
            window.location.href = "/mutualfund/login?returnUrl=/quickbuy";
        } else if (getItem == "unclaimed") {
            // localStorage.removeItem('pageUrl')
            localStorage.clear();
            window.location.href = "/mutualfund/unclaimed/login"
        } else {
            localStorage.clear();
            window.history.replaceState(null, '', '/mutualfund/login');
            // window.history.pushState({ 'hideExpiryPopUp': true }, '', '/mutualfund/login');
            // window.location.href = "/mutualfund/login";

            window.history.pushState(null, '', '/mutualfund/login');
            yield put(push('/login'));

            // yield put(push('/login', { 'hideExpiryPopUp': true }));

        }

        /* if (data?.success) {
            // yield put({ type: LOGOUT_RESPONSE });
            // yield put(push('/mf'));
            window.location.href="/mf";
        } else {
            // yield put(push('/mf'));
            // yield put({ type: LOGOUT_FAILED })
            window.location.href="/mf";
        } */
    } catch (e) {
        // yield put(push('/mf'));
        // yield put({ type: LOGOUT_FAILED })
        window.location.href = "/";
    }
}


export function* rilogout() {
    try {
        let { data } = yield api.logout();
        window.location.href = "/mutualfund/ri/login";
    } catch (e) {
        window.location.href = "/mutualfund/ri/login";
    }
}

